import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_FEEDBACK,
} from '../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';
import { feedbackSelector } from '../../cmsSlice';
import { FEEDBACK_ADD_ACTIVITY_TAB, FEEDBACK_EDIT } from '../../../../constants/FeedbackConst';

const FeedbackView = (props) => {
  const { toggleDrawer, feedback, permissions, onViewToggle } = props;
  const feedbackList = useSelector(feedbackSelector);
  const [selectedFeedback, setSelectedFeedback] = useState(null);

  useEffect(() => {
    if (feedbackList.length) {
      const currFeedback = feedbackList.find((o) => o.id === feedback.id);
      setSelectedFeedback(currFeedback);
    }
  }, [feedbackList, feedback.id]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, selectedFeedback);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(FEEDBACK_EDIT);
  };

  const renderScreen = () => {
    return (
      <div className='row mx-2 feedback-view'>
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Feedback page Title</div>
          <div className='details-value preview-breaks'>{selectedFeedback.pageTitle}</div>
        </div>
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Status</div>
          <div className='details-value col-md-2'>
            <div
              className={`pill ${
                selectedFeedback.isActive ? 'pill-active' : 'pill-inactive theme-dark-green'
              }`}
            >
              <span className='ms-1'>{selectedFeedback.isActive ? 'Active' : 'Inactive'}</span>
            </div>
          </div>
        </div>
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Destination</div>
          <div className='details-value'>{selectedFeedback.destination}</div>
        </div>
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Duration after experience</div>
          <div className='details-value'>{selectedFeedback.duration} mins</div>
        </div>
        <div className='col-md-12 mt-4'>
          <div className='details-label'>Feedback subtext</div>
          <div className='details-value'>{selectedFeedback.subtext || '---'}</div>
        </div>
        <div className='col-md-12 mt-4'>
          <div className='details-label'>Feedback categories</div>
          <div className='details-value'>
            {selectedFeedback.feedbackCategories?.map((categorie, categorieNdx) => (
              <div key={categorieNdx} className='row mt-2'>
                <div className='col-md-6'>
                  <p className='categorie details-label'>Title{categorieNdx + 1}</p>
                  <p className='categorie'>{categorie.title}</p>
                </div>
                <div className='col-md-6'>
                  <p className='categorie details-label'>Feedback type</p>
                  <p className='categorie'>{categorie.type}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {selectedFeedback && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          tabValue={0}
          tabList={FEEDBACK_ADD_ACTIVITY_TAB}
          tabClass='col-md-1'
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          createdUserId={selectedFeedback?.createdBy}
          isEditable={permissions[RBAC_TYPE_CMS_FEEDBACK] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          isHeightIncluded={true}
          title={selectedFeedback?.pageTitle}
        />
      )}
    </>
  );
};

export default FeedbackView;
